import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { InitialiserDependency } from './init.interface';

@Injectable()
export class PaceMsalAuthService extends InitialiserDependency {
    private readonly msalService = inject(MsalService);

    public ready$ = (): Observable<unknown> =>
        this.msalService.handleRedirectObservable().pipe(
            tap(() => {
                const account = this.msalService.instance
                    .getAllAccounts()
                    .find((acc) => acc.username.includes('siemens-healthineers.com'));
                if (!!account) {
                    this.msalService.instance.setActiveAccount(account);
                }
            }),
        );
}
